/* eslint-disable import/prefer-default-export */
export const getFooterNumberFormatter = () =>
  new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
    // @ts-ignore
    // Don't know why Safari(15.6.1+) doesn't honor maximumFractionDigits.
    // Therefore, the experimental roundingPriority is added to force Safari to use the result calculated from maximumFractionDigits.
    roundingPriority: 'lessPrecision'
  })

export const getTooltipNumberFormatter = () =>
  new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  })
